import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-popup"
}
const _hoisted_2 = { class: "cookie-popup__container" }
const _hoisted_3 = { class: "cookie-popup__inner" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "cookie-popup__headline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "cookie-popup__checkbox cookie-popup__checkbox--active" }, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "cookie-popup__headline" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "cookie-popup__headline" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "cookie-popup__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_collapse_transition = _resolveComponent("collapse-transition")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "cookie-popup__logo",
              style: _normalizeStyle(_ctx.logoStyle)
            }, null, 4),
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", { innerHTML: _ctx.text }, null, 8, _hoisted_4),
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("button", {
              class: "cookie-popup__settings-toggle",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleSettings && _ctx.toogleSettings(...args)))
            }, [
              _createVNode(_component_icon, {
                name: _ctx.settingsVisible ? 'icn-upload' : 'icn-download',
                class: "cookie-popup__settings-toggle-icon"
              }, null, 8, ["name"]),
              _createTextVNode(" " + _toDisplayString(_ctx.settingsLabel), 1)
            ]),
            _createVNode(_component_collapse_transition, null, {
              default: _withCtx(() => [
                (_ctx.settingsVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h4", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.technicalLabel), 1)
                      ]),
                      _createElementVNode("div", { innerHTML: _ctx.technicalText }, null, 8, _hoisted_8),
                      _createElementVNode("h4", _hoisted_9, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["cookie-popup__checkbox", { 'cookie-popup__checkbox--active': _ctx.analyticsActive }]),
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.analyticsClicked && _ctx.analyticsClicked(...args)))
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.analyticsLabel), 1)
                      ]),
                      _createElementVNode("div", { innerHTML: _ctx.analyticsText }, null, 8, _hoisted_10),
                      _createElementVNode("h4", _hoisted_11, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["cookie-popup__checkbox", { 'cookie-popup__checkbox--active': _ctx.marketingActive }]),
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.marketingClicked && _ctx.marketingClicked(...args)))
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.marketingLabel), 1)
                      ]),
                      _createElementVNode("div", { innerHTML: _ctx.marketingText }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, _toDisplayString(_ctx.saveLabel), 1),
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.acceptAll && _ctx.acceptAll(...args)))
              }, _toDisplayString(_ctx.agreeAllLabel), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}